import { render, staticRenderFns } from "./VideosList.vue?vue&type=template&id=8d31b79a&scoped=true&"
import script from "./VideosList.vue?vue&type=script&lang=js&"
export * from "./VideosList.vue?vue&type=script&lang=js&"
import style0 from "./VideosList.vue?vue&type=style&index=0&id=8d31b79a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d31b79a",
  null
  
)

export default component.exports